import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { GenericListScreen } from "components/GenericListScreen";
import { Column } from "components/GenericListScreen/types";
import { format } from "date-fns";

interface AttendanceDTO {
    seqId: number;
    userSeqId: number;
    userName: string;
    userId: string;
    attendanceDate: string;
    loginDt?: string;
    consecutiveDays?: number;
    rewardClaimed?: boolean;
    crtDt?: string;
}

const columns: Column<AttendanceDTO>[] = [
    { Header: "Seq ID", accessor: "seqId", width: "7%" },
    { Header: "사용자 ID", accessor: "userId", width: "15%" },
    { Header: "이름", accessor: "userName", width: "10%" },
    { Header: "출석일", accessor: "attendanceDate", width: "12%" },
    {
        Header: "로그인 시간",
        accessor: "loginDt",
        width: "15%",
        Cell: ({ value }: any) => (
            <MDBox lineHeight={1}>
                <MDTypography display="block" variant="caption" fontWeight="medium">
                    {value ? format(new Date(value), "yyyy-MM-dd") : "-"}
                </MDTypography>
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {value ? format(new Date(value), "HH:mm:ss") : ""}
                </MDTypography>
            </MDBox>
        ),
    },
    {
        Header: "연속 출석일",
        accessor: "consecutiveDays",
        width: "10%",
        Cell: ({ value }: any) => <>{value ?? "-"}</>,
    },
    {
        Header: "보상 지급 여부",
        accessor: "rewardClaimed",
        width: "10%",
        Cell: ({ value }: any) => <>{value ? "지급됨" : "미지급"}</>,
    },
    {
        Header: "등록일",
        accessor: "crtDt",
        width: "15%",
        Cell: ({ value }: any) => (
            <MDBox lineHeight={1}>
                <MDTypography display="block" variant="caption" fontWeight="medium">
                    {value ? format(new Date(value), "yyyy-MM-dd") : "-"}
                </MDTypography>
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {value ? format(new Date(value), "HH:mm:ss") : ""}
                </MDTypography>
            </MDBox>
        ),
    },
];

const AttendanceListScreen: React.FC = () => {
    return (
        <GenericListScreen<AttendanceDTO>
            title="출석 관리"
            apiName="Attendance.pagedList"
            columns={columns}
            icon="calendar_today"
        />
    );
};

export default AttendanceListScreen;
